import { ButtonProps } from '@designsystem/stories/02-atoms/Button';
import { MediaProps } from '@designsystem/stories/02-atoms/Media';
import { hasMedia } from '@designsystem/stories/02-atoms/Media.utils';
import type { CardProps as DSCardProps } from '@designsystem/stories/03-molecules/Card';
import Card from '@fhnw/components/Card/Card';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';
import type { ImageSizes } from '@fhnw/helpers/DesignSystem/types';
import { RichText } from '@fhnw/components/RichText';
import type { ButtonSchemaData, MediaSchemaData } from '@fhnw/types/schemaData';

// Marks the injected card inside the listing's items so GridTemplate can
// exclude it from item-derived behaviour (listing type, table columns).
export const TEASER_CARD_UID = 'listing-teaser-card';

export interface TeaserCardProps {
  title?: string;
  text?: string;
  media?: MediaSchemaData;
  actions?: ButtonSchemaData[];
  imageSizes?: ImageSizes;
  className?: string;
}

const withoutCaption = (media?: MediaSchemaData) => {
  if (!media) return media;
  const { image_title, caption, ...rest } = media;
  return rest;
};

const TeaserCard = ({
  title,
  text,
  media,
  actions,
  imageSizes,
  className,
}: TeaserCardProps) => {
  const image = normalizeContent(
    withoutCaption(media),
    true,
    imageSizes,
  ) as MediaProps;
  const buttons = (normalizeContent(actions, true) as ButtonProps[]) || [];

  const card: DSCardProps = {
    type: 'teaser',
    uid: TEASER_CARD_UID,
    title: title || '',
    description: text ? <RichText text={text} /> : undefined,
    // Teaser-card media is fixed to the square format (#1709).
    image: hasMedia(image) ? { ...image, aspect: 'square' } : undefined,
    keepImageAspect: true,
    actions:
      buttons.length > 0
        ? buttons.map((action) => ({
            ...action,
            // Tracking hook for analytics — required on every teaser-card button.
            className: action.className
              ? `${action.className} ga-teasercard-button`
              : 'ga-teasercard-button',
          }))
        : undefined,
  };

  return (
    <Card
      className={
        className ? `listing__teaser-card ${className}` : 'listing__teaser-card'
      }
      card={card}
    />
  );
};

export default TeaserCard;
